import React from "react";

const TermsAndConditions = () => {
    return (
        <div className="font-tiskani" style={{padding: "10rem 3rem 3rem 3rem", paddingTop: "9rem"}}>
            {/*<h1 className="text-3xl font-bold">Uvjeti korištenja</h1>*/}

            <section>
                <h2 className="">Jamstvo privatnosti</h2>
                <p>
                    <strong>Beauty Boutique</strong> obvezuje se čuvati privatnost i
                    povjerljivost osobnih podataka svih svojih kupaca, sukladno Zakonu o
                    zaštiti osobnih podataka (NN 103/2003).
                </p>
                <p>
                    Svi djelatnici Beauty Boutique-a i poslovni partneri ugovorno su
                    obvezani poštivati načela zaštite privatnosti i povjerljivosti
                    podataka. Prikupljamo samo nužne i osnovne podatke o kupcima/korisnicima
                    te ih informiramo o načinu njihove uporabe.
                </p>
                <p>
                    Podaci su dostupni isključivo djelatnicima kojima su nužni za pružanje
                    usluge. Korištenje podataka ograničeno je na izvršavanje narudžbi te
                    informiranje o novostima.
                </p>
                <p>
                    Osobni podaci nikada neće biti dani trećoj strani bez prethodne
                    izričite privole korisnika, osim ako je to zakonom propisano.
                </p>
                <p>
                    Za pitanja ili zahtjeve vezane uz osobne podatke kontaktirajte nas na:{" "}
                    <a href="mailto:info@beautyboutique.hr" className="text-black">
                        info@beautyboutique.hr
                    </a>
                </p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Pravne odredbe</h2>
                <p>
                    Ova stranica predstavlja internet prodavaonicu tvrtke Beauty Boutique.
                    Ne preuzimamo odgovornost za korištenje podataka izvan predviđene
                    svrhe. Plaćanja se izvršavaju putem WSPay sigurnog sustava.
                </p>
                <p>
                    Ulažemo napore u točnost podataka na stranici, ali moguće su razlike.
                    Fotografije su ilustrativne i ne garantiraju potpunu podudarnost s
                    proizvodom.
                </p>
                <p>
                    Za dodatne informacije kontaktirajte nas na:{" "}
                    <a href="mailto:info@beautyboutique.hr" className="text-black">
                        info@beautyboutique.hr
                    </a>
                </p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">
                    Povrat neodgovarajuće ili oštećene robe
                </h2>
                <ul className="list-disc pl-6 space-y-2">
                    <li>
                        Provjerite pošiljku pri primitku. Ako je oštećena, odbijte je i
                        kontaktirajte nas odmah.
                    </li>
                    <li>
                        Ako je isporučena pogrešna roba, javite nam unutar 14 dana e-poštom
                        na <a href="mailto:info@beautyboutique.hr" className="text-black">info@beautyboutique.hr</a>.
                    </li>
                    <li>
                        Proizvodi za povrat moraju biti neupotrebljeni, neoštećeni i u
                        originalnoj ambalaži uz kopiju računa.
                    </li>
                </ul>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">
                    Zamjena krivo naručene robe
                </h2>
                <p>
                    Kupac ima pravo zamijeniti proizvod u roku 14 dana. Potrebno je:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>
                        Poslati zahtjev e-poštom na{" "}
                        <a href="mailto:info@beautyboutique.hr" className="text-black">
                            info@beautyboutique.hr
                        </a>
                    </li>
                    <li>
                        Vratiti robu o svom trošku na našu adresu (upišite svoju adresu).
                    </li>
                    <li>
                        Poslati novu narudžbu. Nova roba bit će poslana po primitku vraćene.
                    </li>
                </ul>
                <p>
                    Kupac snosi trošak dostave. Ako je novi proizvod skuplji, plaća se
                    razlika. Ako je jeftiniji, višak se vraća umanjen za trošak dostave.
                </p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Jednostrani raskid ugovora</h2>
                <p>
                    Kupac ima pravo raskinuti ugovor unutar 14 dana bez navođenja razloga,
                    sukladno Zakonu o zaštiti potrošača.
                </p>
                <p>
                    Povrat robe moguć je unutar 14 dana, a roba mora biti neupotrebljena,
                    neoštećena i u originalnom pakiranju.
                </p>
                <p>
                    Povrat sredstava izvršit će se na isti način kao i plaćanje, osim ako
                    nije dogovoreno drugačije.
                </p>
                <p>
                    Kupac snosi trošak povrata. Odgovoran je za svako umanjenje vrijednosti
                    koje nije nužno za provjeru funkcionalnosti.
                </p>
                <p>
                    Obrazac za jednostrani raskid možete preuzeti{" "}
                    <a href="https://sredisnjikatalogrh.gov.hr/srce-arhiva/263/119771/narodne-novine.nn.hr/clanci/sluzbeni/2014_06_72_1354.html" className="text-black">
                        ovdje
                    </a>
                    .
                </p>
            </section>

            <section>
                <p>
                    Korištenjem internet stranice{" "}
                    <a href="https://www.beautyboutique.hr" className="text-black">
                        www.beautyboutique.hr
                    </a>{" "}
                    potvrđujete da ste u cijelosti upoznati i prihvaćate navedene uvjete i
                    pravilnike.
                </p>
            </section>
        </div>
    );
};

export default TermsAndConditions;
